module.exports = __webpack_public_path__ + "static/media/IMDENAGUA3.17bf931e.jpg";